<template>
  <b-row>
    <b-col cols="12" class="mt-3">
      <b-card header-bg-variant="warning">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left">
            <span class="mb-0 h3 ml-2">金流設定</span>
          </div>
        </template>
        <b-jumbotron header-level="5" header-tag="h3" header="金流">
          <template v-slot:lead>
            該區域規劃將成為多功能金流介接，用以設定不同交易管道，對接至本系統的自動化設定。
          </template>
          <hr class="my-4">
          <h4>
            <font-awesome-icon icon="exclamation-triangle"/> 施工中。
          </h4>
        </b-jumbotron>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons'
library.add(faExclamationTriangle)
export default {}
</script>